import React from 'react';
import TypeDetailCard from './TypeDetailCard';
import type { Memory } from 'types/Memory';
import type { Plugins } from 'types/Plugins';
import SparkInfiniteScroll from 'sharedComponents/UI/SparkInfiniteScroll';
import StepSelectorItemSkeleton from 'sharedComponents/Skeleton/StepSelectorItemSkeleton';

type TypeDetailsContainerProps = {
  memories?: Memory[];
  plugins?: Plugins[];
  isLoading: boolean;
  isFetchingNextPage?: boolean;
  onClick: (selectedStepTypeID: string, resourceID?: string) => void;
  onLastElementView: () => void;
  typeID: string;
  height?: string;
};

function TypeDetailsContainer({
  memories,
  plugins,
  isLoading,
  isFetchingNextPage = false,
  onClick,
  onLastElementView,
  typeID,
  height = '23rem',
}: TypeDetailsContainerProps) {
  const content = React.useMemo(() => {
    if (plugins?.length) {
      return plugins;
    }
    return memories;
  }, [memories, plugins]);

  return (
    <SparkInfiniteScroll
      onLastElementView={onLastElementView}
      height={(content?.length ?? 0) < 10 ? 'auto' : height}
      childContainerProps={{
        md: 12,
        xl: 6,
        padding: 1,
      }}
      isLoading={isLoading}
      loadingContent={<StepSelectorItemSkeleton />}
      isFetchingNextPage={isFetchingNextPage}
    >
      {content?.map((contentItem) => (
        <TypeDetailCard
          key={contentItem.id}
          dataID={contentItem.id}
          icon={contentItem.attributes.iconURL || ''}
          name={contentItem.attributes.name}
          description={contentItem.attributes.description}
          premium={
            'premium' in contentItem.attributes
              ? contentItem.attributes.premium
              : false
          }
          isMemoryModal={!!memories}
          onClick={() => {
            onClick(typeID, contentItem.id);
          }}
        />
      ))}
    </SparkInfiniteScroll>
  );
}

export default TypeDetailsContainer;
